import { history } from '@umijs/max';
import { App } from 'antd';
import { useEffect, useRef } from 'react';
import { doLogout } from '@/utils/authLogout';
import {
  bumpActivity,
  IDLE_LIMIT_MS,
  now,
  readLastActivity,
} from '@/utils/idle';

const ACTIVITY_EVENTS = [
  'click',
  'keydown',
  'mousemove',
  'scroll',
  'touchstart',
] as const;
const loginPath = '/login';
export default function IdleLogout() {
  const { message } = App.useApp();
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (history.location.pathname === loginPath) return;
    // Treat entering protected pages as fresh activity to avoid instant logout
    // due to stale timestamp from a previous session.
    bumpActivity();

    const onActivity = () => bumpActivity();

    const logoutIfIdle = () => {
      const idleFor = now() - readLastActivity();
      if (idleFor >= IDLE_LIMIT_MS) {
        if (timerRef.current) window.clearInterval(timerRef.current);
        for (const evt of ACTIVITY_EVENTS) {
          window.removeEventListener(evt, onActivity as any);
        }
        message.warning('You have been logged out due to inactivity.');
        doLogout();
      }
    };

    for (const evt of ACTIVITY_EVENTS) {
      window.addEventListener(evt, onActivity, { passive: true });
    }

    timerRef.current = window.setInterval(() => {
      logoutIfIdle();
    }, 30_000);

    const onStorage = (e: StorageEvent) => {
      if (e.key === 'token' && !e.newValue) {
        doLogout();
      }
    };
    window.addEventListener('storage', onStorage);

    return () => {
      if (timerRef.current) window.clearInterval(timerRef.current);
      for (const evt of ACTIVITY_EVENTS) {
        window.removeEventListener(evt, onActivity as any);
      }
      window.removeEventListener('storage', onStorage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
